module.exports = __webpack_public_path__ + "img/ctrl-u1-1.b5e6befc.svg";